import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=1ca1b193&scoped=true&"
import script from "./VerifyPhone.vue?vue&type=script&lang=js&"
export * from "./VerifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPhone.vue?vue&type=style&index=0&id=1ca1b193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1b193",
  null
  
)

export default component.exports